// components imports
import { Box, Grid, Typography } from '@mui/material'
import { CustomController } from '../../../common/CustomController'
import { InfoOutlined } from '@mui/icons-material'

// others
import palette from '../../../../theme/palette'

const InfoTooltip = ({ info }: { info: string }) => (
  <Box display="flex" gap={1} pt={1} sx={{ minHeight: '55px' }}>
    <InfoOutlined sx={{ fontSize: '16px', color: '#000000' }} />
    <Typography variant="caption" color="#000000">
      {info}
    </Typography>
  </Box>
)

const ContingencyHybridBillingForm = () => {
  return (
    <Grid container item mt={1.5}>
      <Grid item xs={12} md={6} pr={{ md: 3 }} sx={{ borderRight: { md: 1 }, borderColor: palette.lightGrayThree }}>
        <Typography variant="h3" textTransform="uppercase" fontSize={16} fontWeight={700}>
          Flat Fee
        </Typography>
        <InfoTooltip info="A fixed fee that will be charged upfront" />

        <Box mt={0.5} display="flex" flexDirection="column" gap={2.5}>
          <CustomController
            fieldType="number"
            controllerName="billing.flatFee"
            controllerLabel="Flat Fee ($)"
            dollarAdornment
            sx={{ my: 0 }}
          />
        </Box>
      </Grid>

      <Grid item xs={12} md={6} pl={{ md: 3 }} mt={{ xs: 3, md: 0 }}>
        <Typography variant="h3" textTransform={'uppercase'} fontSize={16} fontWeight={700}>
          Contingency Share
        </Typography>
        <InfoTooltip info="This percentage will be paid once the party won the case and got the amount" />

        <Box mt={0.5} display="flex" flexDirection="column" gap={2.5}>
          <CustomController
            fieldType="number"
            controllerName="billing.contingencyShare"
            controllerLabel="Fee Percentage"
            sx={{ my: 0 }}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default ContingencyHybridBillingForm
